import AddressDetails from 'component/AddressDetails'
import React from 'react'

const MyAddress = () => {
  return (
    <div>
      <AddressDetails/>
    </div>
  )
}

export default MyAddress
